const attributes = [
  {
    field: 'projectNumber',
    kind: 'text',
    label: 'Project Number',
  },
  {
    field: 'phase',
    kind: 'text',
    label: 'Project Phase',
  },
  {
    field: 'estimatedConstructionCost',
    kind: 'text',
    label: 'Estimated Construction Cost',
  },
  {
    field: 'completedDate',
    kind: 'text',
    label: 'Completed Date',
  },
  {
    field: 'facility',
    kind: 'text',
    label: 'Facility',
  },
  {
    field: 'watershed',
    kind: 'text',
    label: 'Watershed',
  },
  {
    field: 'detailsLink',
    kind: 'link',
    label: 'Details Summary',
  },
];

export const projectsLayers = [
  {
    metadata: {
      'lja:identify': {
        'layer-name': 'Maintenance Project',
        'title-field': 'nameWithProjectNumber',
        attributes,
      },
    },
    image: {
      id: 'project-maintenance',
      source:
        'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/icons/circle-green-48/default.png?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
    },
    type: 'symbol' as const,
    filter: ['==', ['get', 'projectType'], 'Maintenance'],
    layout: {
      'icon-image': 'project-maintenance',
      'icon-size': 0.5,
      'text-field': ['get', 'projectNumber'] as ['get', string],
      'text-size': 10,
      'text-padding': 2,
      'text-optional': true,
      'icon-ignore-placement': true,
      'icon-allow-overlap': true,
      'symbol-z-order': 'viewport-y',
    },
    paint: {
      'text-color': 'white',
    },
  },
  {
    metadata: {
      'lja:identify': {
        'layer-name': 'Capital Project',
        'title-field': 'nameWithProjectNumber',
        attributes,
      },
    },
    image: {
      id: 'project-capital',
      source:
        'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/icons/circle-blue-48/default.png?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
    },
    type: 'symbol' as const,
    filter: ['==', ['get', 'projectType'], 'Capital'],
    layout: {
      'icon-image': 'project-capital',
      'icon-size': 0.5,
      'text-field': ['get', 'projectNumber'] as ['get', string],
      'text-size': 10,
      'text-padding': 2,
      'text-optional': true,
      'icon-ignore-placement': true,
      'icon-allow-overlap': true,
      'symbol-z-order': 'viewport-y',
    },
    paint: {
      'text-color': 'white',
    },
  },
  {
    metadata: {
      'lja:identify': {
        'layer-name': 'Grant Project',
        'title-field': 'nameWithProjectNumber',
        attributes,
      },
    },
    image: {
      id: 'project-grant',
      source:
        'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/icons/circle-red-48/default.png?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
    },
    type: 'symbol' as const,
    filter: ['==', ['get', 'projectType'], 'Grant'],
    layout: {
      'icon-image': 'project-grant',
      'icon-size': 0.5,
      'text-field': ['get', 'projectNumber'] as ['get', string],
      'text-size': 10,
      'text-padding': 2,
      'text-optional': true,
      'icon-ignore-placement': true,
      'icon-allow-overlap': true,
      'symbol-z-order': 'viewport-y',
    },
    paint: {
      'text-color': 'white',
    },
  },
  {
    image: {
      id: 'project-highlight',
      source:
        'https://ljamaptiles.blob.core.windows.net/jeffersondd6-styles/icons/circle-highlight-48/default.png?sv=2019-12-12&si=jeffersondd6-styles-webaccess&sr=c&sig=MaYnlUJjE2rK6gp95A6ULpCRd34IXvRFMjn2DcJeZZ8%3D',
    },
    type: 'symbol' as const,
    layout: {
      'icon-image': 'project-highlight',
      'icon-size': 0.5,
      'text-field': ['get', 'projectNumber'] as ['get', string],
      'text-size': 10,
      'text-ignore-placement': true,
      'text-allow-overlap': true,
      'icon-ignore-placement': true,
      'icon-allow-overlap': true,
    },
    paint: {
      'text-color': 'rgba(0, 63, 66, 1)',
      'icon-opacity': ['case', ['boolean', ['feature-state', 'lja:highlight'], false], 1, 0],
      'text-opacity': ['case', ['boolean', ['feature-state', 'lja:highlight'], false], 1, 0],
    },
  },
];
